import React from "react";
import "./confirmationModal.css";
import TextButton from "../../../../components/Buttons/TextButton/TextButton";
import RoundedLinkButton from "../../../../components/Buttons/RoundedLinkButton/RoundedLinkButton";

function ConfirmationModal({ setShowConfirmationModal }) {
  return (
    <>
      <div className="confirmation-modal-component">
        <h2>Aktivera ditt konto</h2>
        <p>Ett aktiveringsmejl har skickats till din e-postadress.</p>
        <br />
        <b>OBS! - Kolla din skräpkorg om du inte hittar mejlet</b>
        <br />
        <br />
        <br />
        <RoundedLinkButton label="Okej!" href={"/"} size="md" />
        <br />
        <br />
        <br />
        <p>
          Har du inte fått något mejl? &nbsp;
          <br />
          <TextButton
            size="xxs"
            color="green"
            label={"Klicka här!"}
            href={"/skicka-validering"}
          />
        </p>
      </div>
      <div
        className="confirmation-modal-backdrop"
        onClick={() => setShowConfirmationModal(false)}
      />
    </>
  );
}

export default ConfirmationModal;
